export default __webpack_public_path__ + "static/fp-full-logo-black-499c7c9dcec5d1fbe5c0c4ab2231d3aa.svg";